import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { useEtherConversion } from 'dibs-crypto-utils/exports/useEtherConversion.ts';
import styles from './styles/NftItemTilePrice.scss';

import { type NftItemTilePrice_etherRates$key } from './__generated__/NftItemTilePrice_etherRates.graphql.ts';

export type Props = {
    etherAmount?: string | null;
    etherRates: NftItemTilePrice_etherRates$key | null | undefined;
    currency: string;
    showFiatPrice?: boolean;
};

const etherRatesFragment = graphql`
    fragment NftItemTilePrice_etherRates on EtherRates @relay(plural: true) {
        ...useEtherConversion_etherRates
    }
`;

export const NftItemTilePrice: FC<Props> = ({
    etherAmount,
    etherRates: etherRatesRef,
    currency,
    showFiatPrice = true,
}) => {
    const etherRates = useFragment(etherRatesFragment, etherRatesRef);
    const { getAmountStrings } = useEtherConversion({
        currency,
        etherRates,
    });
    const { ether, converted: fiatAmount } = getAmountStrings(etherAmount ?? '');

    return (
        <span className={styles.bold}>
            {ether}
            {showFiatPrice ? <span className={styles.fiatPrice}>{fiatAmount}</span> : null}
        </span>
    );
};
